export default __webpack_public_path__ + "static/media/zee_remote_icon_loading2.39861811.svg";